<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <div class="login1">
        <div class="toptitle">
          <p>扫码关注官方微信号</p>
        </div>
        <div class="img"><img :src="picPath" alt="" /></div>
        <div class="bottomNew"><span>请关注公众号</span></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { login, userLogin, bindOpenid } from "../../apis/apis";
export default {
  data() {
    return {
      picPath: "",
      ticket: "",
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getQrcode();
  },
  methods: {
    getQrcode() {
      this.$ajaxGet(`${login}`, {})
        .then((res) => {
          if (res.data.code != 0) {
            this.$message({
              title: "错误",
              type: "error",
              message: res.data.msg + ",请重新刷新",
            });
          }
          this.picPath = res.data.msg;
          let arr = res.data.msg.split("=");
          this.ticket = arr[1];
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
          });
        });
    },
    handleClose() {
      this.$emit("closeDialog");
    },
    //网页长连接保证用户登录
    getconnect() {
      let that = this;
      // 判断浏览器是否支持WebSocket
      let is_support = "WebSocket" in window;
      if (is_support) {
        // 打开一个 web socket
        // let ws = new WebSocket(`${userLogin}/${that.ticket}`);
        let ws = new WebSocket(`${userLogin}/${that.ticket}`);
        ws.onopen = function () {
          console.log("WebSocket连接成功");
          ws.send(that.ticket);
        };
        //  Web Socket 已连接上
        //  接受服务器数据
        ws.onmessage = (e) => {
          const data = JSON.parse(JSON.parse(JSON.stringify(e.data)));
          console.log("websocket", data);
          if (data.openid && data.token) {
            this.$message.success("登录成功", 1);
            sessionStorage.setItem("openid", data.openid);
            this.user.openid = data.openid;
            this.bindOpenid(data.openid, data.phone)
            this.getuserNew(data.openid);
          }
        };
        //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
        window.onbeforeunload = function () {
          ws.close();
        };
      } else {
        this.$alert("浏览器版本过低，请更新浏览器", "警告", {
          confirmButtonText: "确定",
          type: "error",
        });
      }
    },
    bindOpenid(openid, phone) {
      this.$ajaxPost(bindOpenid, {
        openid,
        phone,
      })
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "绑定成功",
            });
          }
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
          });
          throw err;
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__body {
  padding: 0;
}
/deep/.el-dialog__header {
  display: none;
}
//弹出登录框
.login1 {
  display: flex;
  position: fixed;
  font-size: 0.24rem;
  overflow: hidden;
  left: 50%;
  width: 550px;
  height: 583px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  z-index: 1000;
  box-shadow: 0 0 0.1rem #86bbf8;
  border-radius: 0.085937rem;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  .toptitle {
    height: 0.8rem;
    width: 100%;
    color: #fff;
    background-color: #3a88f5;
    font-size: 0.24rem;
    line-height: 0.8rem;
    text-align: center;
    letter-spacing: 0.05rem;
    display: flex;
    justify-content: center;
  }
  .img {
    width: 3.09374rem;
    height: 3.09374rem;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 100%;
      box-shadow: 0 0 0.1rem #86bbf8;
    }
  }
  .bottomNew {
    margin-bottom: 0.343749rem;
    width: 2.5rem;
    font-size: 0.18rem;
    height: 0.3rem;
    border-radius: 0.25rem;
    border: 0.01rem solid #6796e2;
    color: #6796e2;
    line-height: 0.3rem;
  }
  .userphone {
    font-size: 0.16rem;
    text-decoration: underline;
    color: #6796e2;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>